import { replaceCollections, getCollection } from '@fakundo/redux-entities'
import { BILLING } from 'constants/entityNames'
import { refetchMe } from 'actions/me'

export const fetchBilling = cancelToken => (
  (dispatch, getState, api) => api({
    apiPath: 'billing',
    cancelToken,
  })
)

export const refetchBilling = cancelToken => (
  async (dispatch, getState) => {
    if (!getCollection(getState(), BILLING)) return
    const billing = await dispatch(fetchBilling(cancelToken))
    dispatch(replaceCollections({ [BILLING]: billing }))
  }
)

export const createPaymentSource = (stripeTokenDetails, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: 'billing/source',
      data: { stripeTokenDetails },
      cancelToken
    })
    await dispatch(refetchMe())
    await dispatch(refetchBilling())
  }
)

export const deletePaymentSource = (paymentSourceId, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'delete',
      apiPath: `billing/source/${paymentSourceId}`,
      cancelToken
    })
    await dispatch(refetchMe())
    await dispatch(refetchBilling())
  }
)

export const updatePlan = (plan, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'patch',
      apiPath: 'billing/plan',
      data: { plan },
      cancelToken
    })
    await dispatch(refetchMe())
    await dispatch(refetchBilling())
  }
)

export const redeemCoupon = (coupon, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      apiPath: `billing/coupon/${coupon}`,
      cancelToken
    })
    await dispatch(refetchMe())
    await dispatch(refetchBilling())
  }
)
